import { render } from "./CabinetView.vue?vue&type=template&id=56e2694c&ts=true"
import script from "./CabinetView.vue?vue&type=script&lang=ts"
export * from "./CabinetView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__